// function to calculate the start of the week (Monday) for a given date
// accepts a week offset value for next week or last week or n weeks from now
export default (date, monthOffset = 0) => {
  //figure out the day offset for monday
  return new Date(date.getFullYear(), date.getMonth() + monthOffset, 1, 0, 0, 0);
};
